import {BaseSpringServiceCB} from "@aiknow-srl/aik-ngx-http";
import {GatewayPendingConfigOPEEnum} from "./GatewayPendingConfigOPEEnum";
import {DeviceDraftDTO} from "./GatewayPendingConfigPayloadDTO";

class O {
  device!: DeviceDraftDTO;
  fromDraft!: boolean;
}

class I {
  gatewayId!: number;
  deviceId!: number;
}

export class GetDevicePendingConfigCB extends BaseSpringServiceCB {
  public i: I;
  public o: O;

  constructor() {
    super(GatewayPendingConfigOPEEnum.GetDevicePendingConfig);
    this.i = new I();
    this.o = new O();
  }
}
